(function() {
  'use strict';

  var metaEl = document.getElementById('kp-product-data');
  var meta = metaEl ? JSON.parse(metaEl.textContent) : {};
  var productData = {
    variants: JSON.parse(document.getElementById('kp-variants-json').textContent),
    hasOnlyDefault: meta.hasOnlyDefault,
    currentVariantId: meta.currentVariantId,
    title: meta.title
  };

  /* ── Gallery ── */
  var galleryTrack = document.getElementById('kp-gallery-track');
  var galleryMain  = document.getElementById('kp-gallery-main');
  var thumbsEl     = document.getElementById('kp-thumbs');
  var dotsEl       = document.getElementById('kp-dots');
  var currentSlide = 0;
  var slideCount   = galleryTrack ? galleryTrack.children.length : 0;

  function goToSlide(idx) {
    if (!galleryTrack || slideCount === 0) return;
    idx = Math.max(0, Math.min(slideCount - 1, idx));
    currentSlide = idx;
    galleryTrack.style.transform = 'translateX(-' + (idx * 100) + '%)';

    if (dotsEl) {
      Array.from(dotsEl.querySelectorAll('.kp-gallery__dot')).forEach(function(dot, i) {
        dot.classList.toggle('active', i === idx);
      });
    }
    if (thumbsEl) {
      Array.from(thumbsEl.querySelectorAll('.kp-thumb')).forEach(function(th) {
        th.classList.toggle('active', parseInt(th.dataset.index, 10) === idx);
      });
    }
  }

  var prevBtn = document.getElementById('kp-prev');
  var nextBtn = document.getElementById('kp-next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentSlide - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentSlide + 1); });

  if (thumbsEl) {
    thumbsEl.addEventListener('click', function(e) {
      var thumb = e.target.closest('.kp-thumb');
      if (thumb) goToSlide(parseInt(thumb.dataset.index, 10));
    });
  }

  if (dotsEl) {
    dotsEl.addEventListener('click', function(e) {
      var dot = e.target.closest('.kp-gallery__dot');
      if (dot) goToSlide(parseInt(dot.dataset.index, 10));
    });
  }

  if (galleryMain) {
    var touchStartX = 0;
    galleryMain.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        goToSlide(dx < 0 ? currentSlide + 1 : currentSlide - 1);
      }
    }, { passive: true });
  }

  /* ── Variant picker ── */
  var variantIdEl    = document.getElementById('kp-variant-id');
  var buyNowBtn      = document.getElementById('kp-buy-now');
  var atcBtn         = document.getElementById('kp-atc');
  var atcText        = document.getElementById('kp-atc-text');
  var stickyBtn      = document.getElementById('kp-sticky-btn');
  var priceSaleEl    = document.getElementById('kp-price-sale');
  var priceCompareEl = document.getElementById('kp-price-compare');
  var priceBadgeEl   = document.getElementById('kp-price-badge');
  var stickyPriceEl  = document.getElementById('kp-sticky-price');
  var stickyVariantEl = document.getElementById('kp-sticky-variant');
  var oosBanner      = document.getElementById('kp-oos-banner');
  var ctaRow         = document.getElementById('kp-cta-row');
  var notifyCard     = document.getElementById('kp-notify-card');
  var formVariantId  = document.getElementById('kp-form-variant-id');

  /* ── Back-in-stock form (snippets/back-instock.liquid) ──
     Kalles ships an <hdt-back-instock> custom element that keeps the form's
     hidden contact[product] field in sync with its variant <select>, but that
     behaviour lives in global.min.js, which this theme's layout does NOT load.
     So we do the sync here: the shopper must never submit the form against a
     different SKU than the one they are looking at. Attribute + field names are
     read straight off the snippet ([back-instock-select], [back-instock-text],
     name="contact[product]") - do not rename without changing the snippet. */
  var notifySelect   = notifyCard ? notifyCard.querySelector('[back-instock-select]') : null;
  var notifyTextTpl  = notifyCard ? notifyCard.querySelector('[back-instock-text]') : null;
  var notifyProduct  = notifyCard ? notifyCard.querySelector('[name="contact[product]"]') : null;
  /* The template textarea holds "<title> ( nt94_name ) - <origin><url>?variant=nt94_vid" */
  var notifyTemplate = notifyTextTpl ? (notifyTextTpl.value || notifyTextTpl.textContent || '') : '';
  /* Shopify bounces a posted contact form back to the page with ?contact_posted=true.
     Keep the card open in that case so the success/error message is actually seen,
     even if the variant that reloads is an available one. */
  var contactPosted  = /[?&]contact_posted=true/.test(window.location.search);

  function writeNotifyProductField(variantId, variantLabelText) {
    if (!notifyProduct || !notifyTemplate) return;
    notifyProduct.value = notifyTemplate
      .replace('nt94_name', variantLabelText)
      .replace('nt94_vid', variantId);
  }

  function syncNotifyVariant(variant) {
    if (!notifySelect || !variant || variant.available) return;
    var opt = notifySelect.querySelector('option[value="' + variant.id + '"]');
    if (!opt) return;
    notifySelect.value = String(variant.id);
    writeNotifyProductField(variant.id, (opt.textContent || '').trim());
  }

  /* Shopper can also pick a different sold-out variant from the form's own select. */
  if (notifySelect) {
    notifySelect.addEventListener('change', function () {
      var opt = notifySelect.selectedOptions && notifySelect.selectedOptions[0];
      if (!opt) return;
      writeNotifyProductField(notifySelect.value, (opt.textContent || '').trim());
    });
  }

  var optionSelections = meta.initialOptionSelections ? meta.initialOptionSelections.slice() : [];

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  }

  /* ── Real low-stock badge (inventory-driven, variant-aware) ── */
  var stockEl = document.getElementById('kp-stock');
  var inventory = {};
  try {
    var invEl = document.getElementById('kp-inventory-json');
    if (invEl) inventory = JSON.parse(invEl.textContent);
  } catch (e) { inventory = {}; }
  var lowStockThreshold = stockEl ? parseInt(stockEl.dataset.threshold, 10) || 0 : 0;

  function updateStock(variant) {
    if (!stockEl || !variant) return;
    var info = inventory[String(variant.id)];
    stockEl.classList.remove('kp-stock--in', 'kp-stock--low', 'kp-stock--sold');
    if (!variant.available) {
      stockEl.innerHTML = '<span class="kp-stock__icon" aria-hidden="true">✕</span> Sold out';
      stockEl.classList.add('kp-stock--sold');
    } else if (lowStockThreshold > 0 && info && info.tracked && info.policy !== 'continue'
        && info.qty > 0 && info.qty <= lowStockThreshold) {
      stockEl.innerHTML = '<span class="kp-stock__icon" aria-hidden="true">🔥</span> Only <strong>' + info.qty + '</strong> left - order soon!';
      stockEl.classList.add('kp-stock--low');
    } else {
      stockEl.innerHTML = '<span class="kp-stock__icon" aria-hidden="true">✓</span> In stock';
      stockEl.classList.add('kp-stock--in');
    }
  }

  function findVariant() {
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var match = true;
      for (var j = 0; j < optionSelections.length; j++) {
        if (v.options[j] !== optionSelections[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* Build variant label: "Option1 / Option2 / …" (excluding "Default Title") */
  function variantLabel(variant) {
    if (!variant) return '';
    if (productData.hasOnlyDefault) return '';
    var parts = (variant.options || []).filter(function(o) {
      return o && o.toLowerCase() !== 'default title';
    });
    return parts.join(' / ');
  }

  function updateUI(variant) {
    if (!variant) return;

    var salePrice = formatMoney(variant.price);
    if (priceSaleEl) priceSaleEl.textContent = salePrice;
    if (stickyPriceEl) stickyPriceEl.textContent = salePrice;
    if (stickyVariantEl) stickyVariantEl.textContent = variantLabel(variant);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      if (priceCompareEl) { priceCompareEl.textContent = formatMoney(variant.compare_at_price); priceCompareEl.style.display = ''; }
      if (priceBadgeEl)   { priceBadgeEl.textContent = 'SAVE ' + savings + '%'; priceBadgeEl.style.display = ''; }
    } else {
      if (priceCompareEl) priceCompareEl.style.display = 'none';
      if (priceBadgeEl)   priceBadgeEl.style.display = 'none';
    }

    var available = variant.available;
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.dataset.variantId = variant.id;
    }
    if (atcText) atcText.textContent = available ? 'Add to bag' : 'Sold out';
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.dataset.variantId = variant.id;
      stickyBtn.textContent = available ? 'Add to bag' : 'Sold out';
    }
    if (oosBanner) oosBanner.classList.toggle('visible', !available);
    if (variantIdEl) variantIdEl.value = variant.id;
    if (buyNowBtn) buyNowBtn.disabled = !available;

    /* Toggle CTA row vs back-in-stock capture based on variant availability */
    if (ctaRow)  ctaRow.classList.toggle('kp-cta-row--hidden', !available);
    if (notifyCard) notifyCard.classList.toggle('kp-notify-card--hidden', available && !contactPosted);
    /* Point the back-in-stock form at the variant the shopper is actually looking at */
    syncNotifyVariant(variant);
    /* Keep the hidden product form in sync so any app reading it sees the right variant */
    if (formVariantId) formVariantId.value = variant.id;

    updateStock(variant);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    var slides = galleryTrack ? Array.from(galleryTrack.querySelectorAll('.kp-gallery__slide')) : [];
    for (var s = 0; s < slides.length; s++) {
      var vids = (slides[s].dataset.variantIds || '').split(',').map(Number).filter(Boolean);
      if (vids.indexOf(variant.id) !== -1) { goToSlide(s); break; }
    }

    /* Let the other PDP modules (e.g. the "Upgrade Your Experience" bundle, which prices
       the current product as its locked base item) follow the picker. */
    document.dispatchEvent(new CustomEvent('kp:variant:changed', { detail: variant }));
  }

  document.querySelectorAll('.kp-variant-pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      if (pill.classList.contains('unavailable')) return;
      var optIdx = parseInt(pill.dataset.optionIndex, 10);
      var val    = pill.dataset.value;
      optionSelections[optIdx] = val;

      document.querySelectorAll('.kp-variant-pill[data-option-index="' + optIdx + '"]').forEach(function(p) {
        p.classList.toggle('active', p.dataset.value === val);
      });

      var label = document.getElementById('kp-opt-val-' + optIdx);
      if (label) label.textContent = val;

      updateUI(findVariant());
    });
  });

  document.querySelectorAll('.kp-variant-select').forEach(function(sel) {
    sel.addEventListener('change', function() {
      var optIdx = parseInt(sel.dataset.option, 10);
      optionSelections[optIdx] = sel.value;
      var label = document.getElementById('kp-opt-val-' + optIdx);
      if (label) label.textContent = sel.value;
      updateUI(findVariant());
    });
  });

  /* init low-stock badge for the variant on load */
  updateStock(findVariant() || productData.variants.filter(function(v) { return v.id === productData.currentVariantId; })[0]);

  /* init sticky variant label */
  (function() {
    var initialVariant = findVariant() || productData.variants.filter(function(v) { return v.id === productData.currentVariantId; })[0];
    if (stickyVariantEl && initialVariant) {
      stickyVariantEl.textContent = variantLabel(initialVariant);
    }
  })();

  /* ── Quantity stepper ── */
  var qtyInput = document.getElementById('kp-qty-input');
  var qtyMinus = document.getElementById('kp-qty-minus');
  var qtyPlus  = document.getElementById('kp-qty-plus');
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function() {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    });
  }

  /* ── Confetti micro-delight (reduced-motion safe) ── */
  var confettiCanvas = document.getElementById('kp-confetti-canvas');
  var confettiPrefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function launchConfetti() {
    if (!confettiCanvas || confettiPrefersReduced) return;
    var ctx = confettiCanvas.getContext('2d');
    confettiCanvas.width  = window.innerWidth;
    confettiCanvas.height = window.innerHeight;
    confettiCanvas.classList.add('active');

    /* Brand palette confetti pieces */
    var colors = ['#465ae6', '#ff4683', '#fdda0d', '#388e3c', '#0a0a0a'];
    var pieces = [];
    for (var i = 0; i < 80; i++) {
      pieces.push({
        x: Math.random() * confettiCanvas.width,
        y: -10 - Math.random() * 200,
        w: 6 + Math.random() * 8,
        h: 4 + Math.random() * 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * 360,
        vy: 3 + Math.random() * 4,
        vx: (Math.random() - 0.5) * 3,
        vr: (Math.random() - 0.5) * 6
      });
    }
    var frame;
    var startTime = Date.now();
    function draw() {
      var elapsed = Date.now() - startTime;
      if (elapsed > 2000) {
        ctx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
        confettiCanvas.classList.remove('active');
        return;
      }
      ctx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
      pieces.forEach(function(p) {
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      frame = requestAnimationFrame(draw);
    }
    draw();
  }

  /* ── Add to Cart ── */
  function addToCart(variantId, qty, btn) {
    if (!variantId || btn.disabled) return;
    qty = qty || 1;
    btn.disabled = true;
    var originalHTML = btn.innerHTML.trim();
    btn.textContent = 'Adding…';

    var drawerEl  = document.querySelector('hdt-cart-drawer');
    var sectionId = drawerEl ? drawerEl.getAttribute('section-id') : null;
    var payload   = { id: parseInt(variantId, 10), quantity: qty };
    if (sectionId) payload.sections = [sectionId];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { if (!r.ok) throw new Error('fail'); return r.json(); })
    .then(function(addData) {
      btn.textContent = '✓ Added!';
      btn.classList.add('kp-btn-atc--added');

      /* Confetti micro-delight on the main ATC button only */
      if (btn === atcBtn) {
        launchConfetti();
      }

      setTimeout(function() {
        btn.innerHTML = originalHTML;
        btn.classList.remove('kp-btn-atc--added');
        btn.disabled = false;
      }, 2000);

      if (sectionId && addData.sections) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { cartData: addData, source: 'product-form-component', actionAfterATC: 'open_cart_drawer' }
        }));
      }

      /* Badge refresh.

         This used to write `cart.item_count` into every
         `[data-cart-count],[data-count]` element. `[data-count]` also matches
         the cart drawer's own root - `<hdt-cart-drawer … data-count="{{ cart.item_count }}">`
         (sections/cart-drawer.liquid) - so `b.textContent = cart.item_count`
         REPLACED THE ENTIRE DRAWER with the bare number. The <dialog> that had
         just been opened by the cart:update above was destroyed mid-animation,
         which is why Add to Cart looked like "the drawer opens and instantly
         closes", and why html[scroll-lock] was then never released (the drawer
         left the DOM while open, so nothing ever ran its close path). It also
         wiped `.kp-rr__photos[data-count]`, the review-photo row further down
         this same page.

         Dispatch the count on the authoritative channel instead and let the
         owner of each badge redraw itself: kitsters-header.js listens for
         cart:count:update and handles text + .is-empty + the bounce, and
         Kalles' own header bubble listens for the same event. Nothing here
         writes into the DOM any more, so no selector can ever eat a component
         again. */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:count:update', {
            detail: { item_count: cart.item_count, total_price: cart.total_price }
          }));
        })
        .catch(function() { /* badge just keeps its current value */ });
    })
    .catch(function() {
      btn.textContent = 'Error - try again';
      setTimeout(function() { btn.innerHTML = originalHTML; btn.disabled = false; }, 2500);
    });
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      addToCart(variantIdEl ? variantIdEl.value : productData.currentVariantId,
                parseInt(qtyInput ? qtyInput.value : '1', 10) || 1,
                atcBtn);
    });
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      addToCart(variantIdEl ? variantIdEl.value : productData.currentVariantId, 1, stickyBtn);
    });
  }

  if (buyNowBtn) {
    /* Buy Now hands off to Razorpay Magic Checkout, which opens its own
       overlay/popup INSTEAD of navigating. Nothing used to restore the button
       afterwards, so dismissing that popup left "Processing…" disabled on the
       page forever - the shopper could not retry without a reload. Capture the
       real label once (before any mutation) and put the button back the moment
       the shopper is demonstrably back on our page. */
    var buyNowLabel   = buyNowBtn.textContent.trim() || 'Buy it now';
    var buyNowPending = false;
    var buyNowTimer   = null;
    var buyNowArmed   = false;
    var buyNowStarted = 0;
    /* The checkout overlay takes a moment to paint. Ignore interaction-based
       restores inside that window so scrolling the page while it loads does not
       re-enable the button (and open the door to a second add). Leaving and
       coming back is unambiguous, so those paths skip the grace period. */
    var BUY_NOW_GRACE_MS = 1500;
    function backOnPage() { return Date.now() - buyNowStarted > BUY_NOW_GRACE_MS; }

    function restoreBuyNow() {
      if (!buyNowPending) return;
      buyNowPending = false;
      clearTimeout(buyNowTimer);
      buyNowTimer = null;
      /* Re-enable only if the CURRENTLY selected variant is still purchasable -
         the shopper may have switched to a sold-out one while the overlay was
         up. `kp-cta-row--hidden` is the availability flag the variant picker
         maintains; the ATC button's own `disabled` is not usable here because
         addToCart borrows it for its 2s "✓ Added!" state. */
      buyNowBtn.disabled = ctaRow ? ctaRow.classList.contains('kp-cta-row--hidden') : false;
      buyNowBtn.textContent = buyNowLabel;
    }

    /* Any of these means the checkout overlay is gone (or never opened) and the
       shopper is interacting with the product page again. Registered once and
       kept - each one no-ops unless a checkout is actually pending. A trusted
       pointer/key event covers the in-page overlay case, where the document
       never loses visibility or focus and so fires neither of the other two. */
    function armBuyNowRestore() {
      if (buyNowArmed) return;
      buyNowArmed = true;
      /* pageshow restores ONLY on a bfcache return (persisted === true) - the
         redirect-checkout case this path exists for. Measured 2026-08-07: a
         stray persisted=false pageshow fires ~1.2s into the checkout hand-off
         on the preview theme (hot-reload machinery), and an unconditional
         restore re-enabled the button while the checkout overlay was up. A
         non-persisted pageshow is a fresh load, where this script re-runs and
         the button starts in its default state anyway - nothing to restore. */
      window.addEventListener('pageshow', function(e) {
        if (e.persisted) restoreBuyNow();
      });
      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) restoreBuyNow();
      });
      window.addEventListener('focus', function() {
        if (backOnPage()) restoreBuyNow();
      });
      document.addEventListener('pointerdown', function(e) {
        if (e.isTrusted && backOnPage()) restoreBuyNow();
      }, true);
      document.addEventListener('keydown', function(e) {
        if (e.isTrusted && backOnPage()) restoreBuyNow();
      }, true);
    }

    buyNowBtn.addEventListener('click', function() {
      if (buyNowBtn.disabled || buyNowPending) return;
      var variantId = variantIdEl ? variantIdEl.value : productData.currentVariantId;
      if (!variantId) return;
      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      buyNowPending = true;
      buyNowStarted = Date.now();
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Processing…';
      armBuyNowRestore();
      /* Last-resort ceiling: if the checkout never opens and no interaction
         follows (blocked popup, dead network), the button still comes back. */
      clearTimeout(buyNowTimer);
      buyNowTimer = setTimeout(restoreBuyNow, 30000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function(r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function() {
        /* Buy Now stays on this page when Magic Checkout opens its overlay
           instead of navigating - so the cart drawer and header badge must be
           told about the add NOW, or dismissing the overlay leaves them showing
           the pre-add cart until a full reload. cart:reload makes the drawer
           re-fetch its own section HTML without auto-opening (the same silent
           path kitsters-collection.js uses), so it cannot interfere with the
           checkout hand-off; cart:count:update is the badge's authoritative
           channel (see addToCart above - never write badge DOM directly). */
        if (document.querySelector('hdt-cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
        }
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:count:update', {
              detail: { item_count: cart.item_count, total_price: cart.total_price }
            }));
          })
          .catch(function() { /* badge keeps its current value */ });

        /* Route through Razorpay Magic Checkout instead of a raw redirect.
           A programmatic `window.location.href = '/checkout'` is a navigation,
           not a click, so Magic Checkout's delegated click listener never sees it
           and the shopper lands on Shopify's default checkout. Instead we click a
           real hidden name="checkout" submit button (#kp-buynow-checkout), which
           Magic Checkout intercepts - the same path the cart uses. If Magic
           Checkout isn't loaded, the form submits to /checkout as a fallback. */
        var checkoutBtn = document.getElementById('kp-buynow-checkout');
        if (checkoutBtn) {
          checkoutBtn.click();
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function() {
        restoreBuyNow();
      });
    });
  }

  /* Pairs Well / upsell ATC buttons */
  document.querySelectorAll('.kp-pairs-card__atc, .kp-upsell-card__atc').forEach(function(btn) {
    btn.addEventListener('click', function() {
      addToCart(btn.dataset.variantId, 1, btn);
    });
  });

  /* ── Sticky bar IntersectionObserver ── */
  var stickyBar = document.getElementById('kp-sticky-atc');

  /* Named selectors for known chat vendors */
  var KP_CHAT_SELECTORS = [
    '#tawkchat-container', '#tawkchat-minified-box',
    '#tidio-chat', '#tidio-chat-iframe',
    '.crisp-client',
    '#gorgias-chat-container',
    '.intercom-lightweight-app', '#intercom-container',
    '#fc_frame', '#launcher',
    '.wa-chat-btn-container',
    '[id*="whatsapp"]', '[class*="whatsapp"]',
    '[id*="chat-widget"]', '[class*="chat-widget"]',
    '[id*="chat-button"]', '[class*="chat-button"]',
    '[id*="chat-btn"]',   '[class*="chat-btn"]',
    '[id*="livechat"]',   '[class*="livechat"]',
    '[id*="support-chat"]'
  ];

  /* Cache the matched element so MutationObserver stays on the same node. */
  var _chatEl = null;

  function kpFindChatWidget() {
    if (_chatEl && document.contains(_chatEl)) return _chatEl;

    /* 1. Try named selectors */
    for (var i = 0; i < KP_CHAT_SELECTORS.length; i++) {
      var el = document.querySelector(KP_CHAT_SELECTORS[i]);
      if (el && el.id !== 'kp-sticky-atc') { _chatEl = el; return el; }
    }

    /* 2. Fallback: scan all direct children of <body> that are fixed and
          sit in the bottom-right quadrant of the viewport - catches any
          vendor-specific widget regardless of class/id naming. */
    var bodyChildren = document.body.children;
    var vw = window.innerWidth, vh = window.innerHeight;
    for (var j = 0; j < bodyChildren.length; j++) {
      var c = bodyChildren[j];
      if (c.id === 'kp-sticky-atc') continue;
      var cs = window.getComputedStyle(c);
      if (cs.position !== 'fixed') continue;
      var r = c.getBoundingClientRect();
      /* Element visible in bottom 40 % and right 50 % of screen */
      if (r.bottom > vh * 0.6 && r.right > vw * 0.5 && r.width > 0) {
        _chatEl = c; return c;
      }
    }
    return null;
  }

  function kpSetChatBottom(px) {
    var el = kpFindChatWidget();
    if (!el) return;
    if (px) {
      el.style.setProperty('bottom', px, 'important');
      el.style.setProperty('transition', 'bottom 0.3s ease', 'important');
    } else {
      el.style.removeProperty('bottom');
      el.style.removeProperty('transition');
      _chatEl = null; /* clear cache so next open re-detects */
    }
  }

  var _chatObserver = null;

  function kpWatchChatReset(active) {
    if (_chatObserver) { _chatObserver.disconnect(); _chatObserver = null; }
    if (!active) return;
    var el = kpFindChatWidget();
    if (!el) return;
    _chatObserver = new MutationObserver(function() {
      /* Re-apply if the widget's own JS resets bottom */
      if (el.style.bottom !== '80px') kpSetChatBottom('80px');
    });
    _chatObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  if (stickyBar && atcBtn) {
    var observer = new IntersectionObserver(function(entries) {
      var hidden = !entries[0].isIntersecting;
      if (hidden) {
        stickyBar.classList.add('visible');
        document.body.classList.add('kp-atc-bar-visible');
        kpSetChatBottom('80px');
        kpWatchChatReset(true);
      } else {
        stickyBar.classList.remove('visible');
        document.body.classList.remove('kp-atc-bar-visible');
        kpWatchChatReset(false);
        kpSetChatBottom('');
      }
    }, { rootMargin: '-200px 0px 0px 0px' });
    observer.observe(atcBtn);
  }

  /* ── Coupon accordion ── */
  var couponEl      = document.getElementById('kp-coupon');
  var couponTrigger = document.getElementById('kp-coupon-trigger');
  if (couponTrigger) {
    couponTrigger.addEventListener('click', function() {
      var open = couponEl.classList.toggle('open');
      couponTrigger.setAttribute('aria-expanded', open);
    });
  }

  document.querySelectorAll('.kp-code-row__copy').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var code = btn.dataset.code;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function() {
          btn.textContent = 'Copied!';
          btn.classList.add('copied');
          setTimeout(function() { btn.textContent = 'Copy'; btn.classList.remove('copied'); }, 2000);
        });
      }
    });
  });

  /* ── Desktop tabs ── */
  document.querySelectorAll('.kp-tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.dataset.tab;
      document.querySelectorAll('.kp-tab-btn').forEach(function(b) {
        b.classList.toggle('active', b === btn);
        b.setAttribute('aria-selected', b === btn);
      });
      document.querySelectorAll('.kp-tab-panel').forEach(function(p) {
        p.classList.toggle('active', p.dataset.tab === target);
      });
    });
  });

  /* ── Mobile accordion tabs ── */
  document.querySelectorAll('.kp-accordion-tab').forEach(function(tab) {
    var trigger = tab.querySelector('.kp-accordion-tab__trigger');
    if (trigger) {
      trigger.addEventListener('click', function() {
        tab.classList.toggle('open');
      });
    }
  });

  /* ── FAQ accordion (below-fold comic press-down) ── */
  document.querySelectorAll('.kp-faq__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.kp-faq__item');
      var isOpen = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen);
    });
  });

  /* ── Countdown timer ── */
  var countdownEl = document.getElementById('kp-countdown');
  var timerEl     = document.getElementById('kp-countdown-timer');
  if (countdownEl && timerEl) {
    var endTime = new Date(countdownEl.dataset.end).getTime();
    function updateCountdown() {
      var now  = Date.now();
      var diff = endTime - now;
      if (diff <= 0) {
        timerEl.textContent = '00:00:00';
        countdownEl.style.display = 'none';
        return;
      }
      var totalSeconds = Math.floor(diff / 1000);
      var hours   = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      timerEl.textContent =
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* ── Lazy load related products via Recommendations API ── */
  var recsEl = document.getElementById('kp-recommendations');
  if (recsEl) {
    fetch(recsEl.dataset.url)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var relatedSection = doc.querySelector('.kp-related');
      if (relatedSection) {
        recsEl.parentNode.insertBefore(relatedSection, recsEl);
      }
    })
    .catch(function() {});
  }

})();

/* ── Pincode / Delivery Estimator ── */
(function() {
  var pincodeInput  = document.getElementById('kp-pincode-input');
  var pincodeBtn    = document.getElementById('kp-pincode-btn');
  var pincodeResult = document.getElementById('kp-pincode-result');
  if (!pincodeBtn || !pincodeInput || !pincodeResult) return;

  function checkPincode() {
    var pin = pincodeInput.value.trim();
    if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
      pincodeResult.textContent = 'Please enter a valid 6-digit PIN code.';
      pincodeResult.className = 'kp-pincode__result error';
      return;
    }
    pincodeResult.textContent = 'Checking…';
    pincodeResult.className = 'kp-pincode__result';
    setTimeout(function() {
      var today = new Date();
      var deliveryMin = new Date(today.getTime() + 4 * 86400000);
      var deliveryMax = new Date(today.getTime() + 7 * 86400000);
      var fmt = function(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', month: 'short', day: 'numeric' }); };
      pincodeResult.innerHTML = '✅ Estimated delivery: <strong>' + fmt(deliveryMin) + ' - ' + fmt(deliveryMax) + '</strong>';
      pincodeResult.className = 'kp-pincode__result success';
    }, 600);
  }

  pincodeBtn.addEventListener('click', checkPincode);
  pincodeInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkPincode(); });
})();

/* ── Offers toggle ── */
(function() {
  var offersToggle = document.getElementById('kp-offers-toggle');
  var offersBody   = document.getElementById('kp-offers-body');
  if (!offersToggle || !offersBody) return;

  offersToggle.addEventListener('click', function() {
    var expanded = offersToggle.getAttribute('aria-expanded') === 'true';
    offersToggle.setAttribute('aria-expanded', String(!expanded));
    offersBody.hidden = expanded;
  });
})();

/* ── Product Detail Accordions ── */
(function() {
  document.querySelectorAll('.kp-detail-acc__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var body = trigger.nextElementSibling;
      if (!body) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      body.hidden = expanded;
    });
  });
})();

/* ── Product description read-more toggle ── */
(function() {
  var body   = document.getElementById('kp-desc-body');
  var toggle = document.getElementById('kp-desc-toggle');
  if (!body || !toggle) return;
  toggle.addEventListener('click', function() {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    body.classList.toggle('is-expanded', !expanded);
    toggle.textContent = expanded ? 'Read more' : 'Read less';
  });
})();

/* ── Bundle "Upgrade Your Experience" - editable bundle + ATC ──
   Companions are real checkboxes and can be removed; the current product is the base
   item and is deliberately NOT toggleable (you cannot buy the bundle without the
   product you are looking at). Every total, the saving pill, the corner sticker, the
   callout and the button label are recomputed from whatever is actually selected. */
(function() {
  var root = document.querySelector('[data-kp-bundle]');
  if (!root) return;

  var btn         = root.querySelector('[data-bundle-atc]');
  var btnText     = root.querySelector('[data-bundle-atc-text]');
  var baseItem    = root.querySelector('[data-bundle-item="base"]');
  var basePriceEl = root.querySelector('[data-bundle-base-price]');
  var totalEl     = root.querySelector('[data-bundle-total]');
  var compareEl   = root.querySelector('[data-bundle-compare]');
  var saveEl      = root.querySelector('[data-bundle-save]');
  var saveRow     = root.querySelector('[data-bundle-save-row]');
  var stickerEl   = root.querySelector('[data-bundle-sticker]');
  var calloutEl   = root.querySelector('[data-bundle-callout]');
  var calloutText = root.querySelector('[data-bundle-callout-text]');
  var companions  = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item="companion"]'));

  var labelBundle = (btn && btn.dataset.labelBundle) || 'Add Bundle to Cart';
  var labelSingle = (btn && btn.dataset.labelSingle) || 'Add to Cart';
  var baseAvailable = btn ? !btn.disabled : true;

  /* Money is rendered from the shop's own money_format so JS-computed totals match the
     Liquid-rendered prices in the cards exactly (₹ {{amount_no_decimals}} for Kitsters). */
  var moneyFormat = root.dataset.moneyFormat || '₹ {{amount_no_decimals}}';
  function groupDigits(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatMoney(cents) {
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_match, name) {
      var noDecimals = name.indexOf('no_decimals') !== -1;
      var euroStyle  = name.indexOf('comma_separator') !== -1;
      var parts      = (noDecimals ? Math.round(cents / 100).toFixed(0) : (cents / 100).toFixed(2)).split('.');
      var out        = groupDigits(parts[0], euroStyle ? '.' : ',');
      if (parts[1]) out += (euroStyle ? ',' : '.') + parts[1];
      return out;
    });
  }

  function toggleOf(item) { return item.querySelector('[data-bundle-toggle]'); }

  function selectedItems() {
    var items = baseItem ? [baseItem] : [];
    companions.forEach(function(item) {
      var toggle = toggleOf(item);
      if (toggle && toggle.checked && !toggle.disabled) items.push(item);
    });
    return items;
  }

  function show(el, visible) { if (el) el.hidden = !visible; }

  function render() {
    var items = selectedItems();
    var total = 0;
    var compare = 0;
    items.forEach(function(item) {
      total   += parseInt(item.dataset.price, 10) || 0;
      compare += parseInt(item.dataset.compare, 10) || 0;
    });

    var picked  = items.length - (baseItem ? 1 : 0);
    var saving  = compare > total ? compare - total : 0;
    var pct     = saving > 0 ? Math.round(saving * 100 / compare) : 0;
    /* The "Save X%" promise only holds while a companion is actually in the bundle. */
    var showDeal = picked > 0 && pct >= 5;

    if (totalEl)   totalEl.textContent   = formatMoney(total);
    if (compareEl) compareEl.textContent = formatMoney(compare);
    if (saveEl)    saveEl.textContent    = 'You save ' + formatMoney(saving);
    show(saveRow, saving > 0);

    if (stickerEl) stickerEl.textContent = 'Save ' + pct + '%';
    show(stickerEl, showDeal);

    if (calloutText && showDeal) {
      var names = items
        .filter(function(item) { return item !== baseItem; })
        .map(function(item) { return item.dataset.title || ''; })
        .join(' + ');
      var strong = document.createElement('strong');
      strong.textContent = pct + '% off';
      calloutText.textContent = '';
      calloutText.append('Add ' + names + ' and get ', strong, ' the whole bundle - instantly.');
    }
    show(calloutEl, showDeal);

    if (btn) {
      btn.disabled = !baseAvailable;
      btn.setAttribute('aria-disabled', String(!baseAvailable));
    }
    if (btnText) btnText.textContent = picked > 0 ? labelBundle : labelSingle;
  }

  companions.forEach(function(item) {
    var toggle = toggleOf(item);
    if (!toggle) return;
    toggle.addEventListener('change', function() {
      item.classList.toggle('is-deselected', !toggle.checked);
      render();
    });
  });

  /* Keep the base card in sync with the variant picker (price, compare-at, availability). */
  document.addEventListener('kp:variant:changed', function(e) {
    var variant = e.detail;
    if (!variant || !baseItem) return;
    baseItem.dataset.price   = variant.price;
    baseItem.dataset.compare = variant.compare_at_price && variant.compare_at_price > variant.price
      ? variant.compare_at_price
      : variant.price;
    baseItem.dataset.variantId = variant.id;
    if (basePriceEl) basePriceEl.textContent = formatMoney(variant.price);
    baseAvailable = !!variant.available;
    render();
  });

  if (btn) {
    btn.addEventListener('click', function() {
      var items = selectedItems();
      if (!items.length) return;

      /* The base card's variant id can go stale (baked at render time), so prefer the
         id the main ATC is currently pointing at. */
      var mainAtc = document.getElementById('kp-atc');
      var payload = items.map(function(item) {
        var id = item === baseItem && mainAtc && mainAtc.dataset.variantId
          ? mainAtc.dataset.variantId
          : item.dataset.variantId;
        return { id: parseInt(id, 10), quantity: 1 };
      }).filter(function(line) { return !!line.id; });
      if (!payload.length) return;

      var restoreLabel = btnText ? btnText.textContent : '';
      btn.disabled = true;
      if (btnText) btnText.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: payload })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        if (btnText) btnText.textContent = '✓ Added to Cart!';
        window.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function() {
          btn.disabled = !baseAvailable;
          if (btnText) btnText.textContent = restoreLabel;
        }, 2500);
      })
      .catch(function() {
        btn.disabled = !baseAvailable;
        if (btnText) btnText.textContent = 'Try again';
      });
    });
  }

  render();
})();

/* ── PDP FAQ accordion ── */
(function() {
  var faqEl = document.getElementById('kp-pdp-faq');
  if (!faqEl) return;
  faqEl.addEventListener('click', function(e) {
    var trigger = e.target.closest('.kp-faq__trigger');
    if (!trigger) return;
    var body = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!body) return;
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    body.hidden = expanded;
  });
})();

/* ── "Pairs well with" slider arrows ──
   The scrollable element is the wrap (overflow-x: auto), NOT the inner
   flex track (width: max-content, no overflow) - scrollBy/scrollLeft
   must target the wrap or clicks silently no-op. */
(function() {
  document.querySelectorAll('[data-kp-pairs-wrap]').forEach(function(wrap) {
    var container = wrap.closest('.kp-fbt');
    if (!container) return;
    var track   = wrap.querySelector('[data-kp-pairs-track]');
    var prevBtn = container.querySelector('[data-kp-pairs-prev]');
    var nextBtn = container.querySelector('[data-kp-pairs-next]');

    function updateArrows() {
      var atStart = wrap.scrollLeft <= 4;
      var atEnd = Math.round(wrap.scrollLeft + wrap.clientWidth) >= Math.round(wrap.scrollWidth) - 4;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    }

    function scrollByCard(dir) {
      var firstItem = track ? track.querySelector('.kp-pairs-item') : null;
      var gap = track ? (parseInt(window.getComputedStyle(track).columnGap, 10) || 12) : 12;
      var amount = firstItem ? firstItem.offsetWidth + gap : 180;
      wrap.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { scrollByCard(1); });

    requestAnimationFrame(updateArrows);
    var ticking = false;
    wrap.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() { updateArrows(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    wrap.addEventListener('scrollend', updateArrows, { passive: true });
    window.addEventListener('load', updateArrows);
  });
})();

/* ── Creator card "+" click-to-reveal ── */
(function() {
  document.querySelectorAll('.kp-creator-card__plus').forEach(function(btn) {
    var wrap = btn.closest('.kp-creator-card__img-wrap');
    var panel = wrap && wrap.querySelector('.kp-creator-card__reveal');
    if (!panel) return;
    btn.addEventListener('click', function() {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });
})();

/* ── Column SYNCHRONISER - geometry probe only; the motion is CSS ──

   Goal (owner): the short gallery column must reach the bottom of the row at
   the same moment the buy column does, so the left half is not left blank.
   Motion is y = D * progress, D = containerH - columnH.

   THIS FILE NO LONGER ANIMATES. A scroll listener writing `transform` was the
   previous attempt and the owner's verdict was "still jerky" - correctly, and
   unfixably: scrolling is composited, so a main-thread transform lands one
   frame late BY DEFINITION. Optimising the callback cannot move the work to
   the right thread (§10.56 learned this once already).

   So the animation is a CSS **scroll-progress timeline**, which the browser
   runs on the compositor, and this code only publishes the three numbers CSS
   cannot compute - on RESIZE ONLY, never on scroll:

       --kp-travel      D, the distance the column owes
       --kp-sync-start  document scroll offset where the row meets the pin line
       --kp-sync-end    ...and where its bottom reaches the viewport bottom

   WHY `scroll()` AND NOT `view()`: the view-timeline version shipped earlier
   today needed `view-timeline-inset` to line the range up, and an engine can
   pass `@supports (animation-timeline: view())` while mishandling that
   property - the range then maps to the viewport bottom and the gallery sags
   down the screen. That is exactly what the owner saw while it measured
   perfectly here. A scroll-progress timeline takes the range as two absolute
   lengths, so there is no inset to get wrong.

   Degradation: no `scroll()` support (Firefox today) -> the class is never
   added, and the CSS `position: sticky` fallback pins the column. Smooth, but
   the columns do not end together - stated plainly rather than papered over
   with a janky JS path. ── */
(function () {
  var container = document.querySelector('.kp-above-fold');
  var leftCol = container ? container.querySelector('.kp-left-col') : null;
  if (!container || !leftCol) return;

  var CSS_SYNC = window.CSS && CSS.supports &&
                 CSS.supports('animation-timeline', 'scroll()');

  // Must stay identical to the pin's CSS breakpoint (kitsters-product.css) -
  // the width where THIS page becomes two-column, 768px.
  var twoCol = window.matchMedia('(min-width: 768px)');
  // A differential scroll rate reads as parallax; honour the opt-out.
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  var PIN_TOP = 96;          // clears the sticky header, matches the CSS pin

  /* DRIFT_MAX - the column may run at most this many px AHEAD of the page over
     the whole pinned phase. The synchroniser's drift is arithmetic, not a
     choice: it is exactly (viewportH - PIN_TOP - columnH), the empty space
     under the column when it is pinned. Measured 2026-08-18 at 1440px:

         retail PDP,  900px window, column 740px ->  64px drift (looks pinned)
         retail PDP, 1080px window, column 740px -> 244px drift
         Magic Hour,  900px window, column 537px -> 267px drift

     Uncapped, a short column therefore CREEPS DOWN the screen and opens a void
     between the header and the gallery - owner-reported on the Magic Hour PDP
     ("the 2 column synchronise scrolling is not great... use the same
     synchronise scrolling" as the retail PDP). The retail PDP only ever looked
     right because its column happens to be tall enough for the drift to
     vanish, and it has the same defect on a 1080px-tall monitor.

     64px is the retail PDP's own natural drift at 1440x900 - the geometry the
     effect was tuned and signed off on - so this cap is a NO-OP there and
     makes every other column/viewport combination behave like it. Whatever
     travel is given up stays as slack BELOW the gallery, which is what the
     pinned retail PDP already shows, rather than as a gap above it.
     Not capped when the drift is negative (column taller than the visible
     band): there the column must run slower than the page or its own bottom
     never becomes reachable. */
  var DRIFT_MAX = 64;

  var queued = false;

  function off(unpin) {
    leftCol.classList.remove('kp-col-sync');
    // When the flex row WRAPS the columns into one stack, the sticky fallback
    // would pin the gallery while the buy info scrolls underneath it. The
    // desktop row is `flex-wrap: wrap` and two columns do not fit until
    // ~1200px, so 1024-~1150px renders stacked (measured at 1024px: gallery
    // offsetTop 190, buy column offsetTop 1017).
    leftCol.classList.toggle('kp-col-unpin', !!unpin);
  }

  function measure() {
    queued = false;
    if (!CSS_SYNC || !twoCol.matches || calm.matches) return off(false);

    // Columns wrapped/stacked? offsets are layout values, and a transform does
    // not affect layout, so this stays valid while the column is animated.
    var sibling = leftCol.nextElementSibling || leftCol.previousElementSibling;
    if (sibling && Math.abs(leftCol.offsetTop - sibling.offsetTop) > 4) {
      return off(true);
    }

    var colH = leftCol.offsetHeight;
    var travel = container.offsetHeight - colH;
    var range = container.offsetHeight - (window.innerHeight - PIN_TOP);
    if (travel <= 0 || range <= 0) return off(false);

    // DRIFT CAP - see the block comment above. A short column would otherwise
    // slide hundreds of px down the screen over the hero.
    if (travel > range + DRIFT_MAX) travel = range + DRIFT_MAX;

    var top = container.getBoundingClientRect().top + window.pageYOffset;
    var startPx = Math.max(0, Math.round(top - PIN_TOP));

    leftCol.style.setProperty('--kp-travel', travel + 'px');
    leftCol.style.setProperty('--kp-sync-start', startPx + 'px');
    leftCol.style.setProperty('--kp-sync-end', (startPx + Math.round(range)) + 'px');
    leftCol.classList.add('kp-col-sync');
    leftCol.classList.remove('kp-col-unpin');
  }

  function request() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(measure);
  }

  window.addEventListener('resize', request, { passive: true });
  window.addEventListener('load', request);
  if (twoCol.addEventListener) twoCol.addEventListener('change', request);
  if (calm.addEventListener) calm.addEventListener('change', request);

  if (window.ResizeObserver) {
    // Accordions, variant swaps and late-loading images all change the heights
    // D depends on. Deferred a frame so the observer never writes inside its
    // own callback and trips a resize loop.
    var ro = new ResizeObserver(request);
    ro.observe(leftCol);
    ro.observe(container);
  }

  measure();
})();

/* ── Media lightbox ── MOVED 2026-08-17 to assets/kitsters-lightbox.js ──────
   Owner asked for the same zoom on the Magic Hour product page ("Every image
   can be zoom, just like other product page. Also make sure to handle the
   video also"). Rather than copy it there - which is how the two Magic Hour
   surfaces drifted apart in the first place (§10.75) - it is now ONE shared
   file that both PDPs load, with a per-gallery config for the two different
   markup shapes.

   The behaviour here is unchanged: it is the same code, moved. theme.liquid
   does not load it globally; each PDP section loads it beside its own script,
   so no other page pays for it. ── */

/* ── Ratings & reviews card - scroll the review cards row ── */
(function() {
  var btn = document.getElementById('kp-rr-scroll');
  var row = document.getElementById('kp-rr-cards');
  if (!btn || !row) return;
  btn.addEventListener('click', function() {
    var card = row.querySelector('.kp-rr__card');
    var step = card ? card.offsetWidth + 12 : 260;
    row.scrollBy({ left: step, behavior: 'smooth' });
  });
  row.addEventListener('scroll', function() {
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    btn.style.display = atEnd ? 'none' : '';
  }, { passive: true });
})();

/* ── Smooth scroll for the review snapshot → full reviews section ── */
(function() {
  var links = document.querySelectorAll('[data-scroll-to]');
  Array.prototype.forEach.call(links, function(el) {
    el.addEventListener('click', function(e) {
      var target = document.getElementById(el.getAttribute('data-scroll-to'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

